import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCheckmark1Medium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCheckmark1Medium"><Path d="M19.7461 6.7207L10.2041 19.8926L4.23242 14.1904L5.95898 12.3828L9.85938 16.1064L17.7207 5.25488L19.7461 6.7207Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCheckmark1Medium;
